import DataFetch from '../../Utility/data-fetch'

const call = (chapterBaseUrl, bookBaseUrl) => {
    return {
        open: false,

        currentChapterId: '',
        chapters: [],

        currentBookCode: '',
        books: [],

        currentSelection: {},
        testaments: [],
        collections: [],

        loading: false,
        tab: 1,

        async getChapters(biblePassage) {
            // Already in memory? Return.
            if (this.chapters && this.chapters.length > 0) {
                return
            }

            this.currentChapterId = biblePassage.ChapterId
            this.loading = true
            await DataFetch.get(chapterBaseUrl, {
                params: {
                    translationCode: biblePassage.TranslationCode,
                    bookSlug: biblePassage.BookSlug,
                    chapterId: biblePassage.ChapterId,
                },
            })
                .then(response => {
                    this.chapters = response.data.chapters
                    this.loading = false
                })
                .catch(err => {
                    console.log(err)
                    this.loading = false
                })
        },

        async getBooks(biblePassage) {
            // Already in memory? Return.
            if (this.books && this.books.length > 0) {
                return
            }

            this.currentBookCode = biblePassage.BookCode
            this.loading = true
            await DataFetch.get(bookBaseUrl, {
                params: {
                    translationCode: biblePassage.TranslationCode,
                },
            })
                .then(response => {
                    this.books = response.data
                    this.loading = false
                })
                .catch(err => {
                    console.log(err)
                    this.loading = false
                })
        },

        async getBooksByTranslation(translationCode) {
            // Already in memory? Return.
            if (this.books && this.books.length > 0) {
                return
            }

            this.loading = true
            await DataFetch.get(bookBaseUrl, {
                params: {
                    translationCode: translationCode,
                },
            })
                .then(response => {
                    this.books = response.data
                    this.loading = false
                })
                .catch(err => {
                    console.log(err)
                    this.loading = false
                })
        },

        async getFormBookFilterItems() {
            await this.getBooksByTranslation('niv').then(() => {
                this.testaments = [
                    {name: 'Old Testament', code: 'o'},
                    {name: 'New Testament', code: 'n'}]

                this.collections = [
                    {name: 'Books of Law', code: 'law'},
                    {name: 'Books of History', code: 'his'},
                    {name: 'Books of Wisdom', code: 'wis'},
                    {name: 'Major Prophets', code: 'map'},
                    {name: 'Minor Prophets', code: 'mip'},
                    {name: 'The Gospels', code: 'gos'},
                    {name: 'Pauline Epistles', code: 'pep'},
                    {name: 'General Epistles', code: 'gep'},
                    {name: 'Apocalyptic Books', code: 'apo'}]
            })
        },
    }
}

export default call